module.exports = __webpack_public_path__ + "assets/binggun.d4a20e6b.svg";